import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  viewBase: {
    flex: 1,
    height: pixelDimensions(85),
    justifyContent: 'center',
    alignItems: 'center',
  },
  baseScroll: {
    flex: 1,
    marginBottom: Dimensions.get('window').width < 800 ? pixelDimensions(9) : pixelDimensions(7),
  },
  baseCard: {
    borderRadius: 8,
    marginVertical: Dimensions.get('window').width < 820 ? pixelDimensions(3.50) : pixelDimensions(2),
    shadowColor: appColors.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,

    elevation: 7,
  },
  cardContent: {
    backgroundColor: appColors.white,
    width: Dimensions.get('window').width < 750 ? pixelDimensions(93) : pixelDimensions(93),
    flexDirection: 'row',
    borderRadius: 8,
  },
  cardTitle: {
    width: pixelDimensions(33),
    marginRight: pixelDimensions(2),
    paddingRight: pixelDimensions(1),
    borderRightWidth: 1,
    borderRightColor: Colors.blueGrey200,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardTitleText: {
    alignItems: 'center',
    textAlign: 'center',
  },
  cardBody: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardButton: {
    marginTop: pixelDimensions(3),
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(5),
    borderRadius: 8,
    alignItems: 'center',
  },
  paragraphTitle: { color: appColors.darkBlue },
  textButton: {
    color: Colors.white,
    fontFamily: 'MBold',
  },
  imagePlan: {
    borderRadius: 8,
    height: pixelDimensions(16),
    marginBottom: pixelDimensions(1.5),
  },
});

export default styles;
